import { convertDatesToISO, getHeaders } from '@/config/aux'
import { NetworkLogs } from '../models/networkLogs'
import { NetworkLogsStateType } from './state'
import axios from 'axios'

export interface NetworkLogsActionsType {
  getNetworkLogs(): Promise<void>
  getNetworkLogsBySourceId(sourceId: string): Promise<void>
  postNetworkLogs(networkLogs: NetworkLogs): Promise<void>
  putNetworkLogs(networkLogs: NetworkLogs): Promise<void>
  deleteNetworkLogs(id: string): Promise<void>
}

export const NetworkLogsActions = {
  async getNetworkLogs(this: NetworkLogsStateType) {
    try {
      this.networkLogs = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/network-logs`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((networkLog: NetworkLogs) => {
            this.networkLogs.push(networkLog)
          })
        }
      })
    } catch (error) {
      console.error('Error getting NetworkLogs', error)
    }
  },
  async getNetworkLogsBySourceId(this: NetworkLogsStateType, sourceId: string) {
    try {
      this.networkLog = null
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/network-logs/source/${sourceId}`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          this.networkLog = response.data
        }
      })
    } catch (error) {
      console.error('Error getting NetworkLogs by source ID', error)
    }
  },
  async postNetworkLogs(this: NetworkLogsStateType, networkLogs: NetworkLogs) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/network-logs`
      const data = convertDatesToISO(networkLogs.toPlainObject())

      await axios.post(query, data, { headers: getHeaders() }).then(response => {
        if (response.status === 201) {
          // this.networkLogs.push(networkLogs)
        }
      })
    } catch (error) {
      console.error('Error posting NetworkLogs', error)
    }
  },
  async putNetworkLogs(this: NetworkLogsStateType, networkLogs: NetworkLogs) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/network-logs`
      const data = convertDatesToISO(networkLogs.toPlainObject())

      await axios
        .put(query, data, {
          headers: {
            ...getHeaders(),
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          if (response.status === 200) {
            //this.networkLogs = this.networkLogs.map(s => (s.id === networkLogs.id ? networkLogs : s))
          }
        })
    } catch (error) {
      console.error('Error updating NetworkLogs', error)
    }
  },
  async deleteNetworkLogs(this: NetworkLogsStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/network-logs/${id}`
      await axios.delete(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          //this.networkLogs = this.networkLogs.filter(s => s.id !== id)
        }
      })
    } catch (error) {
      console.error('Error deleting NetworkLogs', error)
    }
  },
}
